var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1967_1512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.5H5.25C5.1125 7.5 5 7.6125 5 7.75V8.25C5 8.3875 5.1125 8.5 5.25 8.5H8.75C8.8875 8.5 9 8.3875 9 8.25V7.75C9 7.6125 8.8875 7.5 8.75 7.5ZM8.75 10.5H5.25C5.1125 10.5 5 10.6125 5 10.75V11.25C5 11.3875 5.1125 11.5 5.25 11.5H8.75C8.8875 11.5 9 11.3875 9 11.25V10.75C9 10.6125 8.8875 10.5 8.75 10.5ZM3.5 7.25C3.08437 7.25 2.75 7.58437 2.75 8C2.75 8.41562 3.08437 8.75 3.5 8.75C3.91563 8.75 4.25 8.41562 4.25 8C4.25 7.58437 3.91563 7.25 3.5 7.25ZM3.5 10.25C3.08437 10.25 2.75 10.5844 2.75 11C2.75 11.4156 3.08437 11.75 3.5 11.75C3.91563 11.75 4.25 11.4156 4.25 11C4.25 10.5844 3.91563 10.25 3.5 10.25ZM10.5 2H7.73125C7.74375 1.91875 7.75 1.83438 7.75 1.75C7.75 0.784375 6.96562 0 6 0C5.03438 0 4.25 0.784375 4.25 1.75C4.25 1.83438 4.25625 1.91875 4.26875 2H1.5C0.671875 2 0 2.67188 0 3.5V14.5C0 15.3281 0.671875 16 1.5 16H10.5C11.3281 16 12 15.3281 12 14.5V3.5C12 2.67188 11.3281 2 10.5 2ZM6 1C6.41563 1 6.75 1.33438 6.75 1.75C6.75 2.16563 6.41563 2.5 6 2.5C5.58437 2.5 5.25 2.16563 5.25 1.75C5.25 1.33438 5.58437 1 6 1ZM11 14.5C11 14.775 10.775 15 10.5 15H1.5C1.225 15 1 14.775 1 14.5V3.5C1 3.225 1.225 3 1.5 3H3V3.625C3 3.83125 3.16875 4 3.375 4H8.625C8.83125 4 9 3.83125 9 3.625V3H10.5C10.775 3 11 3.225 11 3.5V14.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1967_1512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.eb7205f8c32897cf6dd6bb05ff19ebc3.svg";
export { ForwardRef as ReactComponent };